export const globalWindow = typeof window === "undefined" ? undefined : window;

export function isServerSide() {
  return typeof window === "undefined";
}
